import React, { useState,useEffect } from 'react';
import { Form, Modal } from 'react-bootstrap';
import { ButtonContainer, StyledButton } from '../../StyledComponets';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDeleteProjectData, getDeleteStatus } from '../../app/projects/deleteProjectSlice';
import { fetchProjectsData } from '../../app/projects/searchProjectSlice';

const DeleteProjectConfirm = (props) => {
  const { confirm, setConfirm,prjData } = props;
  const [agree,setAgree] = useState(false);
  const dispatch = useDispatch();
  const deleteState = useSelector(getDeleteStatus);

  const onDeleteConfirm = () =>{
//CALL DELETE API 
const req= {
  AppNb: prjData.appNb,
  ActionType:'Canceled'
}
 dispatch(fetchDeleteProjectData(req))
  }
 
useEffect(()=>{
  if(deleteState && confirm){
    setConfirm(false);
    setAgree(false);  
    dispatch(fetchProjectsData())
  }
},[deleteState])



  return (
    <Modal
      centered
      size="lg"
      onShow={() => {}}
      onExited={() => {}}
      show={confirm}
      onHide={() => {
        setConfirm(false);
        setAgree(false);
      }}
    >
      <Modal.Body>
        <b>Yes, I wish to withdraw my Interconnection Application from consideration</b>
        <p>Please be advised that if you cancel the application, it will be PERMANENTLY REMOVED and will no longer be able to be reactivated. A new record will need to be created and all submission fees will be re-assessed.</p>
         <span>
         <Form.Check
              type="checkbox"
              value={agree}
              required={true}
              onChange={()=>setAgree(!agree)}
              label={
                <Form.Text size="sm">
                   <b>I confirm I understand the effects of withdrawing this application.</b>
                </Form.Text>
              }
            />
         </span>
       
         <ButtonContainer>
          <StyledButton
            btnType="secondary"
            variant="dark"
            size="md"
            onClick={() => {
              setConfirm(false);
              setAgree(false)
            }}
          >
            Cancel
          </StyledButton>
          <StyledButton
            type="submit"
            btnType="primary"
            variant="dark"
            size="md"
            disabled={!agree}
            onClick={onDeleteConfirm}
          >
            Ok
          </StyledButton>
        </ButtonContainer>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteProjectConfirm;
